// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout_fmY1T","content":"index_content_2Vo0a"};